import React, { PropsWithChildren } from 'react';

import { css } from '@emotion/css';
import { Theme, Typography } from '@mui/material';

import { FontSizes } from '@/assets/fonts';
import { Icons } from '@/assets/icons';
import { useStyles } from '@/hooks/useStyles';
import { FileModel } from '@/models/FileModel';
import { Button } from '@/uiKit/atoms/Button.tsx';

export type FileViewProps = PropsWithChildren<{
  id?: string;
  file: FileModel;
  onDelete?: () => void;
}>;

export const FileView: React.FC<FileViewProps> = ({
  id,
  file,
  children,
  onDelete = undefined,
}) => {
  const styles = useStyles(makeStyles);

  return (
    <div id={id} className={styles.container}>
      <Typography variant="body">{file.name}</Typography>
      <Button
        variant="text"
        className={styles.button}
        onClick={() => window.open(file.url, '_blank')}
        startIcon={<Icons.download className={styles.icon} />}
      />
      {onDelete && (
        <Button
          variant="text"
          className={styles.button}
          onClick={onDelete}
          startIcon={<Icons.trash className={styles.icon} />}
        />
      )}
      {children}
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: ${theme.spacing(4)};
  `,
  pdf: css`
    margin-top: ${theme.spacing(4)};
  `,
  button: css`
    padding: ${theme.spacing(2)};
    :hover {
      background-color: ${theme.palette.action.hover};
    }
    color: ${theme.palette.primary.main};
  `,
  icon: css`
    height: ${FontSizes.body};
    width: ${FontSizes.body};
    margin-right: 0;
  `,
});
